import styled from "styled-components";

export const DataTableWrapper = styled.div`
  height: 70vh;
  overflow: auto;
`